export default "__VITE_ASSET__R9UT4Inm__"